import React from 'react'
import { Routes, Route } from "react-router-dom";
import { lazy } from "react";
// import Home from "./pages/Home/Home";
// import NotFound from "./pages/NotFound/NotFound";
// import ErrorPage from "./pages/ErrorPage/ErrorPage";
// import DynamicPage from "./pages/DynamicPage/DynamicPage";
const DynamicPage = lazy(()=>import('./pages/DynamicPage/DynamicPage'))
const Home = lazy(()=>import('./pages/Home/Home'))
const ErrorPage = lazy(()=>import('./pages/ErrorPage/ErrorPage'))
const NotFound = lazy(()=>import('./pages/NotFound/NotFound'))

export default function AppRoutes() {

    return (
      <Routes>
        <Route path="/" element={
            <div className="crop-container"><Home /></div>
        }/>
        <Route path="/page/servizi-agli-studenti/:slug" element={
            <div className="crop-container"><DynamicPage/></div>
        }/>
        <Route path="/page/student-services/:englishSlug" element={
            <div className="crop-container"><DynamicPage/></div>
        }/>
        <Route path="/page/:news" element={
             <div className="crop-container"><DynamicPage/></div>
        }/>
        <Route path="/post/:postSlug" element={
             <div className="crop-container"><DynamicPage/></div>
        }/>
        <Route path="/notice/:noticeSlug" element={
             <div className="crop-container"><DynamicPage/></div>
        }/>
        <Route path="/event/:eventSlug" element={
             <div className="crop-container"><DynamicPage/></div>
        }/>
        <Route path="/research-seminar/:researchSeminarSlug" element={
             <div className="crop-container"><DynamicPage/></div>
        }/>
        <Route path="/internal-seminar/:internalSeminarSlug" element={
             <div className="crop-container"><DynamicPage/></div>
        }/>
        <Route path="/newsletter/:newsletterSlug" element={
             <div className="crop-container"><DynamicPage/></div>
        }/>
        <Route path="/error" element={
            <ErrorPage/>
        }/>
        <Route path="/*" element={
            <NotFound/>
        }/>
      </Routes>
    );
}